import { PagesCnameStatus } from '@driftt/api-types'

import Config from 'config'
import { DomainTypes } from 'constants/clpSettings'

const getValidDomainSelection = (
  domainSelection: string,
  landingPageCnameStatus: PagesCnameStatus
) => {
  if (landingPageCnameStatus !== PagesCnameStatus.ENABLED) {
    return DomainTypes.DRIFT_CLICK //regardless of selection, reverts to drift.click domain if cname isn't enabled
  }
  if (!!domainSelection) {
    return domainSelection
  }
  if (landingPageCnameStatus === PagesCnameStatus.ENABLED) {
    return DomainTypes.CNAME
  }
  return DomainTypes.DRIFT_CLICK
}

export const getClpDomain = (
  domainSelection: string,
  landingPageCnameStatus: PagesCnameStatus,
  landingPageCname: string,
  landingPageSubdomain: string
) => {
  const validDomainType = getValidDomainSelection(
    domainSelection,
    landingPageCnameStatus
  )

  if (validDomainType === DomainTypes.CNAME) {
    return landingPageCname
  }
  return (
    !!landingPageSubdomain && `${landingPageSubdomain}.${Config.PAGES_HOST}`
  )
}
